// firebase.js
import { initializeApp } from "firebase/app";
import {
  getDatabase,
  ref,
  set,
  onValue,
  push,
  remove,
  get,
  update,
} from "firebase/database";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // ✅ already correct

const firebaseConfig = {
  apiKey: "AIzaSyCMmKtqGo-nx21EtFIOwk4q1Ymy1OTov-s",
  authDomain: "belt-testing-app.firebaseapp.com",
  databaseURL: "https://belt-testing-app-default-rtdb.firebaseio.com",
  projectId: "belt-testing-app",

  // 🔴 FIXED — must match your actual bucket
  storageBucket: "belt-testing-app.firebasestorage.app",

  messagingSenderId: "957536167088",
  appId: "1:957536167088:web:7061050a38f061fb5ac775",
  measurementId: "G-4KWF9VWGLH",
};

const app = initializeApp(firebaseConfig);

// ---- AUTH ----
export const auth = getAuth(app);

// ---- REALTIME DATABASE (EXISTING) ----
export const database = getDatabase(app);
export { ref, set, onValue, push, remove, get, update };

// ---- FIRESTORE (EXISTING) ----
export const firestore = getFirestore(app);

// ---- STORAGE (FIXED — EXPLICIT BUCKET BINDING) ----
export const storage = getStorage(
  app,
  "gs://belt-testing-app.firebasestorage.app"
);

// ---- APP ----
export { app };
